import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

export const SchulungCard = ({ children, title, image, tag = null }) => {
  const schulung_image = getImage(image)
  return (
    <div
      className="card product-card is-flex is-flex-direction-column"
      style={{
        height: "100%",
      }}
    >
      <div
        className="card-image"
        style={{
          position: "relative",
        }}
      >
        {tag ? (
          <div
            style={{ position: "absolute", left: 25, bottom: -12, zIndex: 40 }}
            className={`tag is-rounded has-text-title is-${tag.color}`}
          >
            {tag.text}
          </div>
        ) : null}
        <GatsbyImage image={schulung_image} alt={title} title={title} />
      </div>

      <div
        className="card-content is-flex is-flex-direction-column"
        style={{ flex: "1 1 auto" }}
      >
        <p className="title is-4 mb-4 has-text-mitternachtsblau">{title}</p>
        {children}
      </div>
    </div>
  )
}
